import { PayloadAction } from '@reduxjs/toolkit/src/createAction';
import { ResponseError } from 'types/error.types';
import { Status } from 'redux/types/state.interface';
import { StoreDetailsResponse } from 'interfaces/store-details-page.interfaces';
import { createSlice } from '@reduxjs/toolkit';
import { getStoreComingSoonDetails } from 'components/StoreComingSoon/feature/actions';

type StoreComingSoonDetails = {
  status: Status;
  data: StoreDetailsResponse;
  error: ResponseError | null;
};
const initialState: StoreComingSoonDetails = {
  data: {},
  status: Status.INIT,
  error: null,
};

const slice = createSlice({
  name: 'stores/storeComingSoon',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getStoreComingSoonDetails.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(
        getStoreComingSoonDetails.fulfilled,
        (state, { payload }: PayloadAction<StoreDetailsResponse>) => {
          state.data = payload;
          state.status = Status.FULFILLED;
        },
      )
      .addCase(getStoreComingSoonDetails.rejected, (state) => {
        state.status = Status.ERROR;
      })
      .addDefaultCase((state) => state);
  },
  reducers: {
    reset: () => initialState,
  },
});

export const storeComingSoonDetailsReducer = slice.reducer;
